import React from 'react';
import {
  Button,
  Card,
  Checkbox,
  Col,
  Divider,
  Form,
  Input,
  Layout,
  Row,
  Space,
  Typography,
  Alert,
  notification,
} from 'antd';
import AppLogo from '../../../components/layout/AppLogo';
import AppFooter from '../../../components/layout/AppFooter';
import '../../../styles/styles.less';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setCredentials } from '../../../app/store/authSlice';
import { useLoginMutation } from '../../../app/api/authApiSlice';
import { useGetProfileMutation } from '../../../app/api/profileApiSlice';
import { setProfile } from '../../../app/store/profileSlice';

const { Content } = Layout;
const { Text } = Typography;

interface Credential {
  email: string;
  password: string;
  rememberMe: boolean;
}

const Login: React.FC = () => {
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  const verified = searchParams.get('verified') ?? '';

  const [login, { isLoading }] = useLoginMutation();
  const [getProfile] = useGetProfileMutation();

  const dispatch = useDispatch();

  const handleLogin = ({ email, password, rememberMe }: Credential): void => {
    login({ email, password })
      .unwrap()
      .then(async (userData) => {
        dispatch(
          setCredentials({ token: userData.accessToken, user: email, rememberMe: rememberMe }),
        );

        const profile = await getProfile().unwrap();
        dispatch(setProfile(profile));

        profile === null ? navigate('/profile') : navigate('/');
      })
      .catch((error) => {
        console.log(error);
        // const emailNotConfirmed = error?.data?.errors?.filter(
        //   (a: any) => a.propertyName === 'ConfirmEmail',
        // );

        // if (emailNotConfirmed && emailNotConfirmed?.length > 0) {
        //   notification.error({
        //     message:
        //       'You have not verified your email address yet. Please check your inbox for instructions',
        //     description:
        //       'You have not verified your email address yet. Please check your inbox for instructions',
        //   });

        //   return;
        // }

        // for (const errorMessage of errorMessages) {
        //   showErrorNotification({
        //     message: errorMessage,
        //     error: error,
        //   });
        // }
      });
  };

  return (
    <Layout style={{ background: '#f0f2f5' }}>
      <Content>
        <Row justify='center' align='middle' style={{ minHeight: '100vh' }}>
          <Col xs={20} sm={16} md={12} lg={10} xl={6} xxl={6}>
            <Card>
              <Space direction='vertical' size='middle' style={{ display: 'flex' }}>
                <Row justify='center'>
                  <AppLogo size={128} />
                </Row>
                <Row justify='center'>
                  <Text>Log in or create a new account to access your Seller Account.</Text>
                </Row>
                {verified === 'true' && (
                  <Row justify='center'>
                    <Alert
                      message='Email verification completed. Please use username and password to login.'
                      type='success'
                      closable
                    />
                  </Row>
                )}
                <Form
                  name='login'
                  initialValues={{ rememberMe: true }}
                  onFinish={handleLogin}
                  autoComplete='off'
                >
                  <Form.Item
                    name='email'
                    rules={[
                      {
                        required: true,
                        message: 'Please input your email address!',
                      },
                    ]}
                  >
                    <Input placeholder='Email Address' />
                  </Form.Item>
                  <Form.Item
                    name='password'
                    rules={[
                      {
                        required: true,
                        message: 'Please input your password!',
                      },
                    ]}
                  >
                    <Input.Password placeholder='Password' />
                  </Form.Item>
                  <Form.Item wrapperCol={{ span: 32 }}>
                    <Button type='primary' htmlType='submit' block loading={isLoading}>
                      Log In
                    </Button>
                    <Button
                      type='link'
                      onClick={() => navigate('/forgot-password')}
                      style={{ float: 'right' }}
                    >
                      Forgot Password?
                    </Button>
                  </Form.Item>
                  <Form.Item name='rememberMe' valuePropName='checked' wrapperCol={{ span: 16 }}>
                    <Checkbox>Remember me</Checkbox>
                  </Form.Item>
                </Form>
              </Space>
              <Divider>OR</Divider>
              <Row justify='center' gutter={16}>
                <Col>
                  <Text>{"Don't have an account?"}</Text>
                </Col>
                <Col>
                  <Link to='/signUp'>Sign Up</Link>
                </Col>
              </Row>
            </Card>
            <AppFooter />
          </Col>
        </Row>
      </Content>
    </Layout>
  );
};

export default Login;
